/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import MarketBusinessTypeScreen from '@/screens/setting/market-business-type/MarketBusinessTypeScreen';
import MarketBusinessTypeFormScreen from '@/screens/setting/market-business-type/MarketBusinessTypeFormScreen';

const Stack = createStackNavigator();

const MarketBusinessTypeNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="MarketBusinessTypeScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="MarketBusinessTypeScreen"
        component={MarketBusinessTypeScreen}
        options={() => ({
          // headerRight (mobile ⋯ Add/Export) is owned by the screen so Add goes
          // through openChild and Export reads the scoped params.
          title: setTitleHeader('Market & Business Type'),
        })}
      />
      <Stack.Screen
        name="MarketBusinessTypeFormScreen"
        component={MarketBusinessTypeFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Market Business Type';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            // navigate() to the list (not pop) so back survives a browser
            // refresh, where the list isn't in the fresh stack.
            headerLeft: () => (
              <BackButton
                {...props}
                onPress={() =>
                  props.navigation.navigate('MarketBusinessTypeScreen')
                }
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default MarketBusinessTypeNavigator;
